import React,{useState} from 'react';
import Logo from './Logo';
import {Link} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars} from '@fortawesome/free-solid-svg-icons';
import { faArrowAltCircleRight, faFaceSurprise } from '@fortawesome/free-regular-svg-icons';


const AmbassadorHeader = (props) => {
    const detail=props.detail !== undefined && props.detail



  return (
   <>
    <header>
        <nav className="navbar navbar-expand-lg navbar-light bg-white border-0 ">
            <div className="container px-0 p-md-4">
                
                    {/* <img src={Logo} alt="Logo" className="logo"/> */}
                    <div className="both_logo_wrapper w-100 d-flex justify-content-between">
                        {/* <Logo alt="Logo"/>*/}
                        <Logo className="d-block d-lg-none" alt="Logo"/>
                            <button  className="d-block d-lg-none bg-transparent rounded border" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBackdrop" aria-controls="offcanvasWithBackdrop"><FontAwesomeIcon onClick={() => props.miniSidebar(!true)} icon={faBars}/></button>
                            <FontAwesomeIcon className='d-none d-lg-block' onClick={() => props.miniSidebar(!true)} icon={faBars}/>
                             
                    </div>
                
                
                <button className="navbar-toggler d-none" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                    aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                        <li className="nav-item dropdown">
                            <Link className="nav-link dropdown-toggle" to="/" id="navbarDropdown" role="button"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                Welcome <b><i className="fa fa-user-circle"></i> {detail.name?detail.name:'Ambassador'}</b>
                            </Link>
                            <ul className="dropdown-menu userDropdown" aria-labelledby="navbarDropdown">
                                <li><Link className="dropdown-item" to="/ambassador/dashboard"><i className="fa fa-dashboard pe-2"></i> Dashboard</Link></li>
                                <li><Link className="dropdown-item" to="/ambassador/change-password" state={{detail:detail}}><i className="fa fa-key pe-2"></i> Change Password</Link></li>
                                <li><Link className="dropdown-item" to="/ambassador/login" onClick={()=>sessionStorage.clear()}><i className="fa fa-sign-out pe-2"></i> Logout</Link></li>
                            </ul>
                        </li>
                    </ul>

                </div>
                
                
            </div>
        </nav>
    </header>
   </>
  )
}

export default AmbassadorHeader
